import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useCurrencies() {
    const { t } = useTranslation();

    const currencies = useMemo(() => {
        return [
            {
                name: t('product.productFormConfiguration.usd'),
                value: 'USD',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.eur'),
                value: 'EUR',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.can'),
                value: 'CAD',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.yen'),
                value: 'JPY',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.yuan'),
                value: 'CNY',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.pen'),
                value: 'PEN',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.ars'),
                value: 'ARS',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.mxn'),
                value: 'MXN',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.brl'),
                value: 'BRL',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.pln'),
                value: 'PLN',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.gbp'),
                value: 'GBP',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.huf'),
                value: 'HUF',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.cop'),
                value: 'COP',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.clp'),
                value: 'CLP',
                decimalScale: 0,
            },
            {
                name: t('product.productFormConfiguration.aus'),
                value: 'AUD',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.leu'),
                value: 'RON',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.aed'),
                value: 'AED',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.rsd'),
                value: 'RSD',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.all'),
                value: 'ALL',
                decimalScale: 2,
            },
            {
                name: t('product.productFormConfiguration.mkd'),
                value: 'MKD',
                decimalScale: 2,
            },
        ];
    }, [t]);

    const currenciesHash = useMemo(() => {
        const hash = currencies?.reduce((hash, currency) => (hash[currency.value] = currency) && hash, {});
        return hash || {};
    }, [currencies]);

    return [currencies, currenciesHash];
}
